import type { FieldProps } from 'formik'
import { Icon, ShowIf, TooltipPopOver } from '@ztechapps/webui.util'
import { Form } from 'react-bootstrap'
import type { ReactNode } from 'react'
import React from 'react'

type HelpBlockLayoutProps = { showError: boolean; formikField?: FieldProps; help?: string | ReactNode; meta?: any }
export const HelpBlockLayout = ({ meta, formikField, help, showError }: HelpBlockLayoutProps) => {
  meta = meta || formikField?.meta
  return (
    <>
      <ShowIf condition={help && !showError}>
        <Form.Text muted>{help}</Form.Text>
      </ShowIf>

      <ErrorBlockLayout showError={showError} meta={meta} formikField={formikField} />
    </>
  )
}

export const ErrorBlockLayout = ({ meta, formikField, showError }: HelpBlockLayoutProps) => {
  meta = meta || formikField?.meta

  return (
    <ShowIf condition={showError}>
      <Form.Text className="text-danger">{meta?.error}</Form.Text>
    </ShowIf>
  )
}

type HelpTooltipProps = { help: string | ReactNode }
export const HelpTooltip = ({ help }: HelpTooltipProps) => {
  const isStringTooltip = typeof help === 'string'

  //exit if there is no help
  if (!help) return null

  const content = <Icon name="circle-question" />

  if (isStringTooltip) {
    return <span title={help}>{content}</span>
  }

  //but if the type is ReactNode render using the TooltipOverlay
  return <TooltipPopOver tooltipBody={help}>{content}</TooltipPopOver>
}
